// src/App.tsx
import React from "react";
import AppRoutes from "./routes";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const App: React.FC = () => {
  // Opciones de configuración para PayPal
  const paypalOptions = {
    clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || "",
    currency: "MXN",
    locale: "es_MX",
    components: "buttons",
    "enable-funding": "card",
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "907727704123-8f4fta8nfn2qr91v61pdq75tfadbk7jj.apps.googleusercontent.com"}>
      <PayPalScriptProvider options={paypalOptions}>
        <AppRoutes />
      </PayPalScriptProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
